import { render, staticRenderFns } from "./AllShopsList.vue?vue&type=template&id=4797fe74&scoped=true&"
import script from "./AllShopsList.vue?vue&type=script&lang=js&"
export * from "./AllShopsList.vue?vue&type=script&lang=js&"
import style0 from "./AllShopsList.vue?vue&type=style&index=0&id=4797fe74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4797fe74",
  null
  
)

export default component.exports